
import {Sale} from "@/models/base";
import Vue from "vue";
import {TranslateResult} from "vue-i18n";
import AppInvoiceListEntry from "./InvoiceListEntry.vue";
import AppInvoiceListHeader from "./InvoiceListHeader.vue";

export default Vue.extend({
	data() {
		return {

		};
	},
	props: {
		invoices: {
			type: Array as () => Sale[],
			required: true
		},
		title: {
			type: String,
			required: true
		},
		canBeSigned: {
			type: Boolean,
			required: false
		},
		info: {
			type: String,
			default: ""
		}
	},
	methods: {
		canBeSignedByClient(TypeID: number): boolean{
			return this.canBeSigned;
		},
		invoiceClicked(invoice: Sale) {
			this.$emit("invoice-clicked", invoice);
		},
		onScroll(event: Event) {
			if (!event.target) return;
			let target = event.target as HTMLElement;
			if (target.scrollHeight - (target.scrollTop + target.clientHeight) < 40) {
				this.$emit("fetch");
			}
		},
		getChevron(open: boolean): string {
			if (open) {
				return "chevron-up";
			}
			return "chevron-down";
		},
		getCollapseTooltip(open: boolean): TranslateResult {
			if (open) {
				return this.$ct("collapse-list");
			}
			return this.$ct("expand-list");
		},
		estimateSignClicked(estimate: Sale) {
			this.$emit("estimate-sign-clicked", estimate);
		}
	},
	async created() {
	},
	components: {
		AppInvoiceListEntry,
		AppInvoiceListHeader,
	},
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
});
